var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7497 9.29648C15.2179 6.87014 10.3156 5.76523 6.65689 5.35179C4.82704 5.14503 3.33301 6.67304 3.33301 8.55831V27.333C3.33301 29.2182 4.82704 30.7468 6.65689 30.9535C10.3156 31.367 15.2179 32.4718 18.7497 34.8982V9.29648ZM21.2497 34.8982C24.7813 32.4718 29.6838 31.367 33.3425 30.9535C35.1723 30.7468 36.6663 29.2182 36.6663 27.333V8.55831C36.6663 6.67304 35.1723 5.14503 33.3425 5.35179C29.6838 5.76523 24.7813 6.87014 21.2497 9.29648V34.8982ZM7.09771 13.8996C7.20336 13.2174 7.84206 12.75 8.52429 12.8556C10.6956 13.1919 13.1408 13.754 15.4505 14.6471C16.0944 14.8961 16.4145 15.6199 16.1655 16.2638C15.9165 16.9077 15.1927 17.2278 14.5488 16.9788C12.4511 16.1676 10.1896 15.6434 8.14167 15.3262C7.45946 15.2205 6.99206 14.5818 7.09771 13.8996ZM8.52429 19.5223C7.84206 19.4167 7.20336 19.884 7.09771 20.5663C6.99206 21.2485 7.45946 21.8872 8.14167 21.9928C9.17374 22.1527 10.2632 22.3657 11.3605 22.6425C12.0299 22.8113 12.7095 22.4057 12.8783 21.7362C13.0472 21.0668 12.6415 20.3873 11.9721 20.2185C10.7904 19.9203 9.62384 19.6927 8.52429 19.5223Z",
    fill: "#F8D210"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.b8f1c600645f322241e6680623bb0186.svg";
export { ForwardRef as ReactComponent };